module.exports = __webpack_public_path__ + "img/ban_11.cb8ed098.png";